import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import { circleImg } from '~theme';

const Leadership: React.FC = () => (
  <div tw="grid gap-12 grid-cols-2">
    <div tw="flex flex-col items-start space-y-4">
      <StaticImage
        src="../../images/ron-miller-board-chair.jpg"
        alt=""
        style={circleImg}
        layout="fullWidth"
      />
      <p>
        <strong tw="font-bold">Ron Miller</strong> - Président du conseil d’administration
      </p>
      <div tw="w-32 h-auto max-w-full">
        <StaticImage src="../../images/ron-miller-board-chair-signature.png" alt="" />
      </div>
    </div>
    <div tw="flex flex-col items-start space-y-4">
      <StaticImage
        src="../../images/dave-powten-ceo.jpg"
        alt=""
        style={circleImg}
        layout="fullWidth"
      />
      <p><strong tw="font-bold">Dave Prowten</strong> - Président et chef de la direction</p>
      <div tw="w-32 h-auto max-w-full">
        <StaticImage src="../../images/dave-powten-ceo-signature.png" alt="" />
      </div>
    </div>
  </div>
);

export default Leadership;
